import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'

const STATES = {
    HIDDEN: 'is-hidden',
    SENT: 'is-sent'
}

export default class CourseRating extends Component {

    prepare() {
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)

        EventBus.on('set:completed', this.handleSetCompleted)
        EventBus.on('modal:open', this.handleModalOpen)
    }

    handleStateChange = state => {
        this.render(state)
    }

    handleSetCompleted = () => {
        if (!CourseState.state.rating.sent) {
            this.show()
        }
    }

    handleModalOpen = () => {
        this.hide()
    }

    render(state) {
        const { rating } = state
        const lessons = Object.values(state.lessons)
        const completed = lessons.filter(lesson => lesson.completed).length
        const isCourseComplete = completed > 0 && completed === lessons.length

        if (isCourseComplete && !rating.hidden) {
            this.show()
            if (!rating.sentAll) {
                EventBus.emit('course:completed')
            }
        }

        toggleClass(this.element, STATES.SENT, (isCourseComplete && rating.sentAll) || (!isCourseComplete && rating.sent))
    }

    show() {
        this.element.classList.remove(STATES.HIDDEN)
    }

    hide() {
        this.element.classList.add(STATES.HIDDEN)
    }

}